export default "__VITE_ASSET__BqMHBYL4__"